<template>
    <div class="page">
        <div class="page_header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>了解威有</el-breadcrumb-item>
                <el-breadcrumb-item>发展历程</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="page_headerSecondary">
            <div></div>
            <div>
                <div class="_add">
                    <button @click="openAdd">添加历程</button>
                </div>
                <div class="_operate">
                    <button @click="dialogShow_two = true">修改简介</button>
                </div>
            </div>
        </div>
        <!-- 列表 -->
        <div class="page_content">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="time" align="center" label="历程时间"> </el-table-column>
                <el-table-column prop="intro" align="center" label="历程简述"> </el-table-column>
                <el-table-column prop="status" align="center" label="状态">
                    <template slot-scope="{ row }">
                        <span :style="{ color: row.status ? '#b66dff' : '#fe7c96' }">{{ row.status ? "显示" : "隐藏" }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" align="center" label="操作">
                    <template slot-scope="{ row }">
                        <div class="btns">
                            <div class="_operate">
                                <button @click="openSet(row)">编辑</button>
                            </div>
                            <div class="_delete">
                                <button @click="del(row)">删除</button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 添加或编辑 -->
        <el-dialog
            :title="`${form.id ? '编辑' : '添加'}历程`"
            :visible.sync="dialogShow"
            width="50%"
            :show-close="false"
            :before-close="bfc"
        >
            <el-form :model="form" label-width="80px">
                <el-form-item label="历程简述">
                    <el-input v-model.trim="form.intro"></el-input>
                </el-form-item>
                <el-form-item label="历程时间">
                    <el-date-picker v-model="form.time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch
                        class="sw"
                        v-model="form.status"
                        active-color="#7781f1"
                        inactive-color="#ff4949"
                        active-text="显示"
                        inactive-text="隐藏"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">取 消</el-button>
                <el-button type="primary" @click="yes">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑简介 -->
        <el-dialog title="编辑简介" :visible.sync="dialogShow_two" width="50%" :show-close="false" :before-close="bfc">
            <el-input type="textarea" autosize v-model.trim="intro" resize="none"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow_two = false">取 消</el-button>
                <el-button type="primary" @click="updateIntro">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import QueryString from "qs";
export default {
    data() {
        return {
            tableData: [],
            form: {},
            dialogShow: false,
            intro: {},
            dialogShow_two: false,
        };
    },

    async created() {
        this.getData();
    },

    methods: {
        async getData() {
            let { data } = await axios.get("/api/development_history/show ");
            this.tableData = data.filter(e => e.id != 1);
            this.intro = data.find(e => e.id == 1).intro;
        },
        // 打开添加
        openAdd() {
            this.form = {
                status: 1,
                time: "",
                intro: "",
            };
            this.dialogShow = true;
        },
        // 打开编辑
        openSet(row) {
            this.form = { ...row };
            this.dialogShow = true;
        },
        // 确认
        async yes() {
            let form = { ...this.form };
            if (form.id) {
                // 编辑
                var { data } = await axios.put("/api/development_history/update", QueryString.stringify(form));
            } else {
                // 添加
                var { data } = await axios.post("/api/development_history/add", QueryString.stringify(form));
            }
            if (data.code != 200) {
                this.$message.error(data.msg);
                return;
            } else {
                this.$message.success(data.msg);
            }
            this.getData();
            this.dialogShow = false;
        },
        // 删除
        async del({ id }) {
            let s = await this.$confirm("是否确认删除?", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => true);
            if (!s) return;
            let { data } = await axios.delete("/api/development_history/del", { params: { id } });
            if (data.code != 200) {
                this.$message.error(data.msg);
            } else {
                this.$message.success(data.msg);
            }
            this.getData();
        },
        // 修改简介
        async updateIntro() {
            // this.dialogShow_two=true
            let { intro } = this;
            let { data } = await axios.put("/api/development_history/fup", QueryString.stringify({ intro }));
            if (data.code != 200) {
                this.$message.error(data.msg);
                return;
            } else {
                this.$message.success(data.msg);
            }
            this.getData();
            this.dialogShow_two = false;
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    .page_headerSecondary {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .page_content {
        margin-top: 20px;
        .el-table {
            border-radius: 20px;
        }
        .btns {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
    }
}
.sw {
    /deep/.el-switch__label.is-active {
        color: #7781f1 !important;
    }
}
</style>
